/* Trust Signals — mobile auto-rotate.
   Reads data-autoplay-speed (seconds) and data-transition-ms from the
   section wrapper, set via the theme editor range sliders. */
(function () {
  document.querySelectorAll('.trust-signals-bar').forEach(function (bar) {
    var items = bar.querySelectorAll('.trust-signals-item');
    if (items.length < 2) {
      if (items[0]) items[0].classList.add('is-active');
      return;
    }

    var speedSeconds = parseFloat(bar.dataset.autoplaySpeed || '2');
    var transitionMs = parseInt(bar.dataset.transitionMs || '600', 10);
    bar.style.setProperty('--trust-transition-ms', transitionMs + 'ms');

    var index = 0;
    items[index].classList.add('is-active');

    setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, Math.max(speedSeconds, 1) * 1000);
  });
})();
